export default {
  title: 'Akceptacja regulaminów',
  type: 'object',
  properties: {
    termsIds: {
      type: 'array',
      items: {
        type: 'number'
      },
      validFunc: '$external.requiredLength === $value.length',
      validationMessages: {
        validFunc: 'Pole wymagane'
      }
    }
  }
};
